import { Component, OnDestroy, OnInit, Input, ChangeDetectionStrategy } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Subscription } from "rxjs";
import { ApeFooterService, FooterLayout, FooterBackground } from "./ape-footer.service";
import { ApeLogoComponent } from "../ape-logo/ape-logo.component";
import { TranslatePipe } from "../../pipe/translation.filter.pipe";
import { TRANSLATION_KEYS } from "../../constants/translations/translation-keys";

/**
 * Componente footer dell'applicazione con logo e informazioni aziendali
 * Supporta due modalità: homepage (con payoff e logo) e pagine interne (solo copyright)
 * Implementa accessibilità completa per screen reader e navigazione da tastiera
 */
@Component({
  selector: "ape-footer",
  templateUrl: "./ape-footer.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    CommonModule,
    ApeLogoComponent,
    TranslatePipe
  ]
})
export class ApeFooterComponent implements OnInit, OnDestroy {
  /**
   * Chiavi di traduzione per type safety
   */
  readonly TRANSLATION_KEYS = TRANSLATION_KEYS;

  /**
   * Layout corrente del footer
   */
  footerLayout: FooterLayout = "minimal";

  /**
   * Background del footer (input per override esterno)
   */
  @Input() footerBackground: FooterBackground = "transparent";

  /**
   * Background interno del footer (gestito dal servizio)
   */
  protected internalFooterBackground: FooterBackground = "transparent";

  private subscription: Subscription = new Subscription();

  constructor(private footerService: ApeFooterService) { }

  /**
   * Inizializza il componente e sottoscrive ai cambiamenti del layout footer
   */
  ngOnInit() {
    this.subscription.add(this.footerService.footerLayout$.subscribe(layout => {
      this.footerLayout = layout;
    }));

    this.subscription.add(this.footerService.footerBackground$.subscribe(background => {
      this.internalFooterBackground = background;
    }));
  }

  /**
   * Pulisce le sottoscrizioni per evitare memory leaks
   */
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  get currentYear(): string {
    return "" + new Date()
      .getFullYear();
  }
}
